(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["thrive-pincode-eta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('thrive-pincode-eta')) return;

    var STORAGE_KEY = 'thrive-pincode';
    var DAY_MS = 86400000;
    var IST_OFFSET_MS = 330 * 60000;

    // Turn "14, 15, 160" into a list of prefixes.
    function parsePins(text) {
      return String(text || '').split(/[^0-9]+/).filter(function (p) { return p.length > 0 && p.length <= 6; });
    }

    // Find the zone for a pincode: the longest matching prefix wins.
    // Returns {min, max}, or null when the pincode isn't valid or isn't served.
    function zoneFor(pin, opts) {
      if (!/^[1-9][0-9]{5}$/.test(pin)) return null;
      var best = null, bestLen = 0;
      opts.zones.forEach(function (z) {
        parsePins(z.pins).forEach(function (prefix) {
          if (prefix.length > bestLen && pin.indexOf(prefix) === 0) { best = z; bestLen = prefix.length; }
        });
      });
      if (best) return best;
      return opts.deliverOther ? opts.fallback : null;
    }

    // Dates are handled as midnight-UTC values that stand for IST calendar days.
    function istNow() {
      var d = new Date(Date.now() + IST_OFFSET_MS);
      return { day: Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()), hour: d.getUTCHours(), minute: d.getUTCMinutes() };
    }

    function isoDay(t) { return new Date(t).toISOString().slice(0, 10); }

    function isWorkingDay(t, opts) {
      if (opts.sundayOff && new Date(t).getUTCDay() === 0) return false;
      return opts.holidays.indexOf(isoDay(t)) === -1;
    }

    function nextWorkingDay(t, opts) {
      do { t += DAY_MS; } while (!isWorkingDay(t, opts));
      return t;
    }

    function addWorkingDays(t, n, opts) {
      for (var i = 0; i < n; i++) t = nextWorkingDay(t, opts);
      return t;
    }

    function estimate(pin, now, opts) {
      var zone = zoneFor(pin, opts);
      if (!zone) return null;
      var minDays = Math.min(zone.min, zone.max), maxDays = Math.max(zone.min, zone.max);
      var shipsToday = isWorkingDay(now.day, opts) && now.hour < opts.cutoff;
      var dispatch = shipsToday ? now.day : nextWorkingDay(now.day, opts);
      // Store holidays stop dispatch only; couriers still deliver on those days.
      var transitOpts = { sundayOff: opts.sundayOff, holidays: [] };
      return {
        shipsToday: shipsToday,
        dispatch: dispatch,
        from: addWorkingDays(dispatch, minDays, transitOpts),
        to: addWorkingDays(dispatch, maxDays, transitOpts),
        minutesLeft: shipsToday ? (opts.cutoff * 60) - (now.hour * 60 + now.minute) : 0
      };
    }

    function fmt(t) {
      return new Date(t).toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    }

    function countdown(mins) {
      var h = Math.floor(mins / 60), m = mins % 60;
      return (h ? h + ' hr ' : '') + m + ' min';
    }

    window.ThrivePincodeEta = { zoneFor: zoneFor, estimate: estimate };

    class ThrivePincodeEta extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input');
        this.result = this.querySelector('.thrive-eta__result');
        var zones = [];
        try { zones = JSON.parse(this.dataset.zones); } catch (e) {}
        this.opts = {
          cutoff: parseInt(this.dataset.cutoff, 10) || 14,
          sundayOff: this.dataset.sundayOff === 'true',
          holidays: (this.dataset.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
          zones: zones,
          deliverOther: this.dataset.other !== 'false',
          fallback: { min: parseInt(this.dataset.defaultMin, 10) || 4, max: parseInt(this.dataset.defaultMax, 10) || 6 }
        };
        this.input.addEventListener('input', () => {
          this.input.value = this.input.value.replace(/[^0-9]/g, '').slice(0, 6);
        });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.check(true); });

        var saved = null;
        try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
        if (saved && /^[0-9]{6}$/.test(saved)) { this.input.value = saved; this.check(false); }
      }

      check(save) {
        var pin = this.input.value.trim();
        var est = estimate(pin, istNow(), this.opts);
        this.result.classList.remove('is-error');
        if (!est) {
          this.result.classList.add('is-error');
          this.result.textContent = pin.length === 6
            ? 'Sorry, we can’t confirm delivery to this pincode. Message us and we’ll check for you.'
            : 'Please enter a valid 6-digit pincode.';
          return;
        }
        if (save) { try { localStorage.setItem(STORAGE_KEY, pin); } catch (e) {} }
        var range = est.from === est.to ? fmt(est.from) : fmt(est.from) + ' – ' + fmt(est.to);
        var dispatchLine = est.shipsToday
          ? 'Order within <strong>' + countdown(est.minutesLeft) + '</strong> to ship today.'
          : 'Ships ' + fmt(est.dispatch) + '.';
        this.result.innerHTML =
          '<p class="thrive-eta__date">Delivery by <strong>' + range + '</strong> to ' + pin + '</p>' +
          '<p class="thrive-eta__sub">' + dispatchLine + '</p>';
      }
    }

    customElements.define('thrive-pincode-eta', ThrivePincodeEta);
  })();
  } catch(e) { console.error(e); }
})();

})();
